const isProduction = process.env.REACT_APP_ENVIRONMENT_NAME === 'prod';
export default isProduction;
